module.exports = __webpack_public_path__ + "img/safepal.527c005e.png";